import React from 'react';

const TournamentRevamp: React.FC<{}> = () => {
	return <div />;
};

export default TournamentRevamp;
